<template lang="pug">
  .b2b-table-facturas-emitidas
    //- Filtro Tabla Facturas Emitidas
    b2b-filters-facturas-emitidas(
      :filter-options='options' @updateEmmited="refreshInvoices")

    //- Tabla de Facturas Emitidas
    ods-table(
      v-loading="loading"
      :data='emittedPayrolls.tableData',
      :start-sort='{ prop: "creationDateTime", order: "descending"}',
      style='width: 100%',
      @sort-change="orderOnServer",
      @selection-change='handleSelectionChange',
      highlight-current-row,
      size='small',
      fit)
      ods-table-column(
        type='selection',
        width='45')
      ods-table-column(
        prop='sent',
        v-if='isShowSentInEmittedSearch',
        width='50')
        template(slot-scope='scope')
          //- Enviada
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.sent') }}
            ods-icon.coloricon(
              v-if='scope.row.sent!==null && scope.row.sent',
              name='send',
              size='15')
      ods-table-column(
        prop='sellerName',
        :label='$t("invoices.invoices_entity_table.seller")',
        :show-overflow-tooltip='true',
        v-if='isShowVendedorFactura',
        sortable='')
      //- centreSellerCodes oculta por defecto
      ods-table-column(
        prop='centreSellerCodes',
        :label='$t("invoices.invoices_entity_table.seller_centre")',
        :show-overflow-tooltip='true',
        v-if='isShowCentroVendedorFactura',
        sortable='')
      ods-table-column(
        prop='buyerName',
        :label='$t("invoices.invoices_entity_table.buyer")',
        :show-overflow-tooltip='true',
        v-if='isShowCompradorFactura',
        sortable='')
      //- centreBuyerCodes oculta por defecto
      ods-table-column(
        prop='centreBuyerCodes',
        :label='$t("invoices.invoices_entity_table.buyer_generic_centre")',
        :show-overflow-tooltip='true',
        v-if='isShowCentroGenericCompradorFactura',
        sortable='')
      ods-table-column(
        prop='centreBuyer',
        :label='$t("invoices.invoices_entity_table.buyer_centre")',
        v-if='isShowCentroCompradorFactura && canViewDistributionCentres',
        sortable='')
        template(slot-scope='scope')
          ods-tooltip(placement='top-end')
            template(slot='content')
              | {{ scope.row.centreBuyer }}
              br
              | {{ scope.row.centreBuyerTooltip }}
            div.text-overflow-tooltip
              | {{ scope.row.centreBuyer }}
      ods-table-column(
        prop='centreBuyerDeliveryPoint',
        :label='$t("invoices.invoices_entity_table.buyer_delivery_centre")',
        v-if='isShowCentroEntregaCompradorFactura && canViewDistributionCentres',
        sortable='')
        template(slot-scope='scope')
          ods-tooltip(placement='top-end')
            template(slot='content')
              | {{ scope.row.centreBuyerDeliveryPoint }}
              br
              | {{ scope.row.centreBuyerDeliveryPointTooltip }}
            div.text-overflow-tooltip
              | {{ scope.row.centreBuyerDeliveryPoint }}
      ods-table-column(
        prop='centreBuyerInvoicee',
        :label='$t("invoices.invoices_entity_table.buyer_invoicee_centre")',
        v-if='isShowCentroFacturadoCompradorFactura && canViewDistributionCentres',
        sortable='')
        template(slot-scope='scope')
          ods-tooltip(placement='top-end')
            template(slot='content')
              | {{ scope.row.centreBuyerInvoicee }}
              br
              | {{ scope.row.centreBuyerInvoiceeTooltip }}
            div.text-overflow-tooltip
              | {{ scope.row.centreBuyerInvoicee }}
      ods-table-column(width='130',
        prop='invoiceSeriesCode',
        :label='$t("invoices.invoices_entity_table.series_code")',
        :show-overflow-tooltip='true',
        v-if='isShowNumSerieFactura',
        sortable='')
      ods-table-column(width='150',
        prop='invoiceNumber',
        :label='$t("invoices.invoices_entity_table.invoice_number")',
        :show-overflow-tooltip='true',
        v-if='isShowNumeroFactura',
        sortable='')
      ods-table-column(
        prop='issueDate',
        :label='$t("invoices.invoices_entity_table.issue_date")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowEmisionFactura',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        prop='creationDateTime',
        :label='$t("invoices.invoices_entity_table.creation_date")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowFechaRegistroFactura',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        prop='documentClass',
        :label='$t("invoices.invoices_entity_table.invoice_class")',
        :show-overflow-tooltip='true',
        v-if='isShowClaseFactura',
        :formatter='formatterClass'
        sortable='')
      ods-table-column(width='110',
        prop='totalExecutableAmount',
        :label='$t("invoices.invoices_entity_table.amount")',
        align='right',
        :show-overflow-tooltip='true',
        v-if='isShowImporteFactura',
        :formatter='formatterMoney',
        sortable='')
      ods-table-column(
        prop='status',
        :label='$t("invoices.invoices_entity_table.status")',
        v-if='isShowEstadoFactura',
        sortable='')
        template(slot-scope='scope')
        template(slot-scope='scope')
          ods-tooltip(placement='top')
            template(slot='content')
              | {{ formatterTooltipInvoiceStatus(scope.row, scope.column) }}
            div.text-overflow-tooltip
              span(:class="{ 'text-red': canViewStatusColor && scope.row.status && (scope.row.status.toUpperCase() === 'ERROR' || scope.row.status.toUpperCase() === 'REJECTED' || scope.row.status.toUpperCase() === 'REJECTED_REDIGITALIZATION' || scope.row.status.toUpperCase() === 'ANNULLED' || scope.row.status.toUpperCase() === 'CANCELLED') }")
                | {{ formatterInvoiceStatus(scope.row, scope.column) }}
      ods-table-column(width='115',
        prop='communicationMethod',
        :label='$t("invoices.invoices_entity_table.communication_method")',
        :show-overflow-tooltip='true',
        v-if='isShowEnvioFactura',
        :formatter='formatterCommunicationMethod'
        sortable='')
      //- Ocultas por defecto
      ods-table-column(
        prop='currencyCode',
        :label='$t("invoices.invoices_entity_table.currency")',
        :show-overflow-tooltip='true',
        v-if='isShowDivisaFactura',
        :formatter='formatterCurrency',
        sortable='')
      ods-table-column(width='130',
        prop='registerNumber',
        :label='$t("invoices.invoices_entity_table.register_number")',
        :show-overflow-tooltip='true',
        v-if='isShowNumRegistroFactura',
        sortable='')
      ods-table-column(
        prop='cancellationRequest',
        :label='$t("invoices.invoices_entity_table.cancellation")',
        :show-overflow-tooltip='true',
        align='center',
        v-if='isShowAnulacionFactura',
        :formatter='formatterBoolean',
        sortable='')
      ods-table-column(
        prop='projectName',
        :label='$t("invoices.invoices_entity_table.project")',
        :show-overflow-tooltip='true',
        v-if='isShowServicioFactura',
        sortable='')
      ods-table-column(
        prop='thirdPartyName',
        :label='$t("invoices.invoices_entity_table.thirdParty")',
        :show-overflow-tooltip='true',
        v-if='isShowTerceroInEmittedSearch',
        sortable='')
      ods-table-column(
        prop='channel',
        align='center'
        :label='$t("invoices.invoices_entity_table.channel")',
        v-if='isShowCanalFactura',
        sortable='')
        template(slot-scope='scope')
          ods-tooltip(placement='top')
            template(slot='content')
              | {{ scope.row.descriptionChannel }}
            div.text-overflow-tooltip
              | {{ scope.row.channel}}
      ods-table-column(
        prop='id',
        :label='$t("invoices.invoices_entity_table.id_invoice")',
        :show-overflow-tooltip='true',
        v-if='isShowIdDatabaseFactura',
        sortable='')
      ods-table-column(width='135',
        prop='paymentMethod',
        :label='$t("invoices.invoices_entity_table.paymentMethod")',
        :show-overflow-tooltip='true',
        v-if='isShowPaymentMethod',
        :formatter='formatterPaymentMethod',
        sortable='')
      ods-table-column(
        prop='accountingDate',
        :label='$t("invoices.invoices_entity_table.accountingDate")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowAccountingDate',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        prop='paymentDate',
        :label='$t("invoices.invoices_entity_table.paymentDate")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowPaymentDate',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        width='50')
        template(slot-scope='scope')
          //- Adjuntos
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.attachments') }}
            ods-icon(
              v-if='scope.row.withAttachment!==null && scope.row.withAttachment',
              name='clip',
              size='15')
      //- Columna con QUICK-ACCIONS-BUTTONS
      ods-table-column(
        label,
        align='center',
        :render-header='renderHeaderActions',
        width='130')
        //- Accions emmited
        //- 1 Download Pdf
        template(slot-scope='scope' placement='center')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.downloadPDF') }}
            ods-button(
              style=' padding-left: 0px; padding-right: 0px;',
              type='neutral',
              icon-position='left'
              @click='handleDownloadPdf(scope.row)')
              ods-icon(name='download', size='16')
          //- 2 Details
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.detail') }}
            ods-button(
              style=' padding-left: 10px; padding-right: 0px;'
              type='neutral'
              @click='handleGoDetail(scope.row)')
              ods-icon(name='search', size='16')
          //- 3 PopOver emitidas
          ods-popover(
          placement="bottom-end"
          trigger="hover")
            ul.__quick-accions
              li
                ods-button(
                  icon='ods-icon-download'
                  icon-position='left'
                  @click.native='handleDownloadSignedOriginal(scope.row)' type='neutral' style=' padding-left: 0px; padding-right: 0px;')
                  span {{ $t('invoice_detail.buttons.download_original_signed_tooltip')}}
              li
                ods-button(
                  v-if="canDownloadFormatted && scope.row.documentFormat.startsWith('INVOIC')",
                  icon='ods-icon-download'
                  icon-position='left'
                  @click.native='handleDownloadOriginalformatted(scope.row)' type='neutral' style=' padding-left: 0px; padding-right: 0px;')
                  span {{ $t('invoice_detail.buttons.download_original_formatted_tooltip')}}
              li
                ods-button(
                  v-if="showVisualizeXslButton(scope.row)",
                  icon='ods-icon-external-link'
                  icon-position='left'
                  @click.native='handleDownloadXLS(scope.row)' type='neutral' style=' padding-left: 0px; padding-right: 0px;')
                  span {{ $t('buttons.btnDownloadXSL')}}
              li
                ods-button(
                  v-if="((!(scope.row.pathFileMetadata != null) && (canAdminIndra && scope.row.documentFormat!='XML_B2B_INVOICE')) || (canAdminIndra && scope.row.communicationMethod && (scope.row.communicationMethod=='PAPER' || scope.row.communicationMethod=='EMAIL')))",
                  icon='ods-icon-download'
                  icon-position='left'
                  @click.native='handleGenerateMetadata(scope.row)' type='neutral' style=' padding-left: 0px; padding-right: 0px;')
                  span {{ $t('invoice_detail.buttons.generate_metadata_tooltip')}}
              li
                ods-button(
                  v-if="(canAdminIndra || canViewMetadataEmission) && scope.row.pathFileMetadata != null"
                  icon='ods-icon-file'
                  icon-position='left'
                  @click.native="handleDownloadMetadata(scope.row)" type='neutral' style=' padding-left: 0px; padding-right: 0px;')
                  span {{ $t('buttons.btnViewMetadata')}}
              li
                ods-button(
                  v-if="showResendButton(scope.row)",
                  icon='ods-icon-send'
                  icon-position='left'
                  @click.native='handleResendInvoice(scope.row)',
                  type='neutral' style=' padding-left: 0px; padding-right: 0px;')
                  span {{ $t('buttons.btnReSend')}}
              li
                ods-button(
                  v-if="canCreateCorrectiveInvoice",
                  icon='ods-icon-plus'
                  icon-position='left'
                  @click.native='handleCreateInvoice(scope.row)',
                  type='neutral' style=' padding-left: 0px; padding-right: 0px;')
                  span {{ $t('buttons.btnCreateInvoice')}}
              li
                ods-button(
                  v-if='canGetPaymentData && (scope.row.status.toUpperCase() === "SENT_TO_PAYMENT" || scope.row.status.toUpperCase() === "PAID")'
                  icon='ods-icon-refund'
                  icon-position='left'
                  @click.native='handleCheckPayment(scope.row)',
                  type='neutral' style=' padding-left: 0px; padding-right: 0px;')
                  span {{ $t('invoice_detail.buttons.check_payment_emit_tooltip')}}
            ods-button(
              slot="reference",
              icon-position='right'
              type='neutral')
              ods-icon(name='overflow-menu', size='16')
    //- Paginación Tabla
    ods-row.b2b-table-facturas-emitidas__pagination(v-if='emittedPayrolls.totalEmittedPayrolls > 0')
      ods-col.b2b-table-facturas-emitidas__pagination--left(:span='4')
        ods-tooltip(:content='$t("invoices.buttons.download_csv_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            size='mini',
            round='',
            icon='ods-icon-download'
            style='display:inline;'
            @click='handleDownloadAllCsvEmitted')
            | CSV
      ods-col.b2b-table-facturas-emitidas__pagination--right(:span='20')
        div.block(style='margin-bottom: 50px;')
          ods-pagination(
            ref='pagination',
            popper-class='b2b-pagination__dropdown',
            @size-change='handleSizeChange',
            @current-change='handleCurrentChangePagination',
            :current-page.sync='currentPage',
            :page-sizes='[20, 50, 100]',
            :page-size='20',
            layout='total, sizes, prev, pager, next, slot',
            :total='emittedPayrolls.totalEmittedPayrolls')

    //- Facturas Emitidas Seleccionadas
    transition(
      name='slide',
      mode='out-in')
      b2b-table-select-rows(
        v-if='multipleSelection.length',
        :total-select='multipleSelection.length')
        div(slot='actions')
          ods-tooltip(:content='$t("invoices.buttons.download_invoices_tooltip")', placement='bottom')
            ods-button(
              icon='ods-icon-download',
              size='small',
              circle,
              @click.native='handleDownloadInvoice')
              | {{ $t('invoices.buttons.download_invoices') }}
          ods-tooltip(:content='$t("invoices.buttons.download_invoice_signed_tooltip")', placement='bottom')
            ods-button(
              icon='ods-icon-download',
              size='small',
              circle,
              @click.native='handleDownloadOriginalInvoice')
              | {{ $t('invoices.buttons.download_invoice_signed') }}
          ods-tooltip(:content='$t("buttons.btnReSend")', placement='bottom')
            ods-button(
              v-if="canResendEmittedInvoices"
              icon='ods-icon-download',
              size='small',
              circle,
              @click.native='openhandleResendMultiple')
              | {{ $t('buttons.btnReSend') }}
          ods-tooltip(:content='$t("buttons.btnChangestatus")', placement='bottom')
            ods-button(
              v-if='canEditInvoices || canChangeStatusInvoice'
              icon='ods-icon-download',
              size='small',
              circle,
              @click.native='handleChangestatusMultiple')
              | {{ $t('buttons.btnChangestatus') }}
    //- Dialog Reenviar Factura -- dropdown
    ods-dialog(
      ref='dialogResendInvoice',
      :title='$t("invoice_detail.dialog_resend_invoice.title")',
      :visible.sync='isShowDialogResendInvoice',
      @open='handleEmailsForResendInvoice'
      @close='handleCloseDialog'
      width='30%')
      ods-form(
        ref='formDialogResendInvoice',
        :model='dialogResendInvoiceForm',
        :rules='rulesDialogResendInvoiceForm')
        ods-form-item(
          :label='$t("invoice_detail.dialog_resend_invoice.communication_method.label")',
          prop='communicationMethodId')
          ods-select(
            :no-match-text='$t("msg_generics.no_match")',
            v-model='dialogResendInvoiceForm.communicationMethodId',
            filterable,
            :placeholder='$t("invoice_detail.dialog_resend_invoice.communication_method.placeholder")'
            @change='handleEmailsForResendInvoice')
            ods-option(
              v-for='option in metodosenvio',
              :key='option.id',
              :label='$t("communication_method." + option.code)',
              :value='option.id')
        ods-form-item(
          :label='$t("invoice_detail.dialog_resend_invoice.new_emails")',
          prop='newEmails',
          v-if= 'showInputNewEmails(dialogResendInvoiceForm.communicationMethodId)')
          ods-input(v-model='dialogResendInvoiceForm.newEmails')
        ods-form-item__label(
          v-if='showInputNewEmails(dialogResendInvoiceForm.communicationMethodId) && isMultipleResend()')
          | {{ $t('invoice_detail.dialog_resend_invoice.multiple_emails') }}
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='submitResendInvoice("formDialogResendInvoice")')
          | {{ $t('buttons.btnConfirm') }}
    //- Dialog CAmbio de estado -- dropdown
    ods-dialog(
      ref='dialogChangestatus',
      :title='$t("buttons.btnChangestatus")',
      :visible.sync='isShowDialogChangestatus',
      @close='handleCloseDialog'
      width='30%')
      ods-form(
        ref='formDialogChangestatus',
        :model='formDialogChangestatus',
        :rules='rulesDialogChangestatusForm')
        ods-form-item(
          :label='$t("invoice_detail.invoice_detail_edit_form.change_state.label")',
          prop='statusId')
          ods-select(
            :no-match-text='$t("msg_generics.no_match")',
            v-model='formDialogChangestatus.statusId',
            filterable,
            :placeholder='$t("invoice_detail.invoice_detail_edit_form.change_state.placeholder")'
            @change='changeStatus')
            ods-option(
              v-for='option in optionsFilterInvoiceStatus',
              :key='option.id',
              :label='$t("invoice_status." + option.code)',
              :value='option.id')
        ods-form-item(
          :label='$t("invoice_detail.invoice_detail_edit_form.observations")',
          prop='observations')
          ods-input(v-model='formDialogChangestatus.observations')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='submitChangeStatus("formDialogChangestatus")')
          | {{ $t('buttons.btnConfirm') }}
    payment-data-dialog(
      :showDialog="isShowDialogPaymentData",
      :paymentsData='this.paymentsData',
      :emitted='true'
      :invoiceNumber='this.invoiceNumber',
      @setterShowPaymentDataDialog='setterShowPaymentDataDialog')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bFiltersFacturasEmitidas from '@/views/facturas/emitidas/B2bFiltersFacturasEmitidas'
import B2bTableMenuFacturas from '@/views/facturas/emitidas/B2bTableMenuFacturas'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import filters from './filtros-facturas-emitidas'
import moment from 'moment'
import Utils from '@/components/shared/Utils'
import PaymentDataDialog from '@/views/facturas/PaymentDataDialog'

export default {
  name: 'b2b-table-facturas-emitidas',
  mixins: [Utils],
  data () {
    const validateEmail = (rule, value, callback) => {
      // si no hay valor
      if (!value || value.trim() === '') {
        // Reenvio mutiple
        if (this.isMultipleResend()) {
          callback() // Todo válido
        } else {
          callback(new Error(this.$t('invoice_detail.dialog_resend_invoice.no_emails'))) // Campo vacío no es válido
        }
      } else {
        const emails = value.split(';').map(email => email.trim()) // Dividir y limpiar espacios
        if (emails.length > 5) {
          callback(new Error(this.$t('invoice_detail.dialog_resend_invoice.max_emails'))) // Máximo 5 correos
        } else {
          const invalidEmails = emails.filter(email => !this.checkCorrectEmail(email)) // Validar cada email
          if (invalidEmails.length > 0) {
            callback(new Error(this.$t('invoice_detail.dialog_resend_invoice.email_format'))) // Formato inválido
          } else {
            callback() // Todo válido
          }
        }
      }
    }
    return {
      // Tabla
      currentRow: {},
      multipleSelection: [],
      multipleSelectionIds: [],
      // Paginación
      currentPage: null,
      loading: false,
      // PAYMENT
      paymentsData: [],
      invoiceNumber: null,
      isShowDialogPaymentData: false,

      isShowDialogResendInvoice: false,
      isShowDialogChangestatus: false,
      dialogResendInvoiceForm: {
        communicationMethodId: null,
        isDefault: null,
        newEmails: ''
      },
      formDialogChangestatus: {
        statusId: null,
        observations: null
      },
      rulesDialogResendInvoiceForm: {
        communicationMethodId: [{
          required: true,
          message: this.$t('msg_generics.field_required'),
          trigger: 'change'
        }],
        newEmails: [{
          validator: validateEmail,
          trigger: 'change'
        }]
      },
      metodosenvio: [],
      project: null,
      searchType: 'EMITTED'
    }
  },

  computed: {
    ...mapGetters([
      'emittedPayrolls',
      'queryEmittedPayrolls',
      'optionsFilterCurrency',
      'optionsFilterPaymentMethod',
      'isShowCompradorFactura',
      'isShowNumeroFactura',
      'isShowEmisionFactura',
      'isShowFechaRegistroFactura',
      'isShowClaseFactura',
      'isShowImporteFactura',
      'isShowEstadoFactura',
      'isShowEnvioFactura',
      'isShowVendedorFactura',
      'isShowDivisaFactura',
      'isShowNumRegistroFactura',
      'isShowNumSerieFactura',
      'isShowCentroVendedorFactura',
      'isShowCentroGenericCompradorFactura',
      'isShowCentroCompradorFactura',
      'isShowCentroEntregaCompradorFactura',
      'isShowCentroFacturadoCompradorFactura',
      'isShowAnulacionFactura',
      'isShowServicioFactura',
      'isShowTerceroInEmittedSearch',
      'isShowCanalFactura',
      'isShowIdDatabaseFactura',
      'isShowAccountingDate',
      'isShowPaymentDate',
      'isShowPaymentMethod',
      'isShowSentInEmittedSearch',
      // Permisos
      'canAdminIndra',
      'canViewStatusColor',
      'urlIn',
      'getActiveLang',
      'canResendEmittedInvoices',
      'canChangeStatusInvoice',
      'optionsFilterInvoiceStatus',
      'canEditInvoices',
      'canDownloadFormatted',
      'canViewDistributionCentres',
      'canGetPaymentData',
      'canViewMetadataEmission',
      'canCreateCorrectiveInvoice'
    ]),
    rulesDialogChangestatusForm () {
      const checkObservations = (rule, value, callback) => {
        const self = this
        const estado = this.optionsFilterInvoiceStatus.find(function (t) {
          return t.id === self.formDialogChangestatus.statusId
        })
        const observations = this.formDialogChangestatus.observations
        if (estado && (estado.code === 'REJECTED' || estado.code === 'CANCELLED' ||
              estado.code === 'ERROR' || estado.code === 'ANNULLED') &&
              !observations) {
          callback(new Error(this.$t('msg_generics.field_required')))
        } else {
          callback()
        }
      }
      return {
        observations: [
          { max: 255, message: this.$t('msg_generics.max_num_character', { max: 255 }), trigger: 'blur' },
          { validator: checkObservations, trigger: 'blur, change' }
        ]
      }
    }
  },

  components: {
    B2bFiltersFacturasEmitidas,
    B2bTableMenuFacturas,
    B2bTableSelectRows,
    PaymentDataDialog
  },

  methods: {
    refreshInvoices () {
      this.loading = true
      this.$forceUpdate()
      setTimeout(() => this.loading = false, 2000) // eslint-disable-line
    },
    ...mapActions([
      'getOptionsService',
      'getPayrolls',
      'queryEmittedPayrollsState',
      'handleDownloadAllCsv',
      'handleDownloadMultiInvoiceNotesPdf',
      'handleDownloadMultiInvoiceSignedOriginal',
      'handleResendMultipleInvoices',
      'selectInvoiceNote',
      'downloadInvoiceFormatted',
      'getInvoiceNote',
      'visualizeWithXsl',
      'generateMetadata',
      'downloadMetadata',
      'getOptionsProjectCommunicationsMethods',
      'getProjectByName',
      'modifyMultipleStatus',
      'optionsFilterServiceState',
      'createInvoiceState',
      'getInvoicePaymentData',
      'getResendEmailsInvoiceNote'
    ]),

    showVisualizeXslButton (row) {
      try {
        this.handleCellMouseEnter(row)
        return (row.documentFormat === 'FATTURAPA12' || row.documentFormat === 'FACTURAE32' ||
          row.documentFormat === 'FACTURAE321' || row.documentFormat === 'FACTURAE322' ||
          row.documentFormat === 'FATTURAPA12_CADES' || row.documentFormat === 'FATTURAPA_SEMPLIFICATA' ||
          row.documentFormat === 'FATTURAPA_SEMPLIFICATA_CADES')
      } catch (error) {
        console.log('showVisualizeButton CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    // Mostrar botón reenviar factura
    showResendButton (row) {
      this.handleCellMouseEnter(row)
      let result = false
      try {
        if (row.emission !== null && row.status !== 'RETAINED') {
          // permiso para reenviar
          if (this.canResendEmittedInvoices) {
            result = true
          }
        }
      } catch (error) {
        console.log('showResendButton CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
      return result
    },

    // saber si es envio multiple o no
    isMultipleResend () {
      return (this.multipleSelectionIds !== undefined && this.multipleSelectionIds !== null && this.multipleSelectionIds.length !== 0)
    },

    // Mostrar input para introducir nuevos emails a los que reenviar la factura
    showInputNewEmails (communicationMethodId) {
      const selectedOption = this.metodosenvio.find(option => option.id === communicationMethodId)
      if (selectedOption) {
        // Lista de códigos permitidos
        const allowedCodes = ['EMAIL', 'EMAIL_PDF', 'EMAIL_SIGNED', 'EMAIL_SIGNED_ATTACH', 'EMAIL_PDF_SIGNED', 'EMAIL_PDF_SIGNED_ATTACH', 'EMAIL_PDF_ATTACH', 'EMAIL_LINK'] // Reemplaza con los códigos deseados
        return allowedCodes.includes(selectedOption.code)
      }
      return false
    },

    // Ordenar Tabla
    async orderOnServer ({ column, order, prop }) {
      let stringSort = ''
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.order_table')
      })

      if (order === 'descending') {
        order = 'DESC'
      } else if (order === 'ascending') {
        order = 'ASC'
      } else {
        order = 'ASC'
      }

      if (!prop) {
        prop = 'creationDateTime'
      } else {
        switch (prop) {
          case 'buyerName':
            prop = 'partyByIdBuyer.tradeName'
            break
          case 'sellerName':
            prop = 'partyByIdSeller.tradeName'
            break
          case 'centreBuyerCodes':
            prop = 'codeCentresBuyer'
            break
          case 'centreBuyer':
            prop = 'centreBuyer.centreCode'
            break
          case 'centreBuyerDeliveryPoint':
            prop = 'centreDeliveryPoint.centreCode'
            break
          case 'centreBuyerInvoicee':
            prop = 'centreInvoicee.centreCode'
            break
          case 'centreSellerCodes':
            prop = 'centreSeller.centreCode'
            break
          case 'thirdPartyName':
            prop = 'partyByIdThird.tradeName'
            break
          case 'status':
            prop = 'statusDocumentByIdStatus.status'
            break
          case 'channel':
            prop = 'channels.code'
            break
          case 'communicationMethod':
            prop = 'communicationsMethodByIdCommunicationMethod.name'
            break
        }
      }

      stringSort = prop + ',' + order
      this.queryEmittedPayrolls.sort = stringSort

      try {
        if (this.urlIn && this.urlIn !== 'b2b') {
          this.queryEmittedPayrolls.urlName = this.urlIn
        } else {
          this.queryEmittedPayrolls.urlName = null
        }
        await this.queryEmittedPayrollsState(this.queryEmittedPayrolls)
        dataQuery.query = this.queryEmittedPayrolls
        const payrolls = await this.getPayrolls(dataQuery)
        console.log('PAYROLLS:::: ', payrolls)
      } catch (error) {
        console.log('orderOnServer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Descargar todos a CSV
    async handleDownloadAllCsvEmitted () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_csv')
      })
      try {
        const params = this.queryEmittedPayrolls
        if (this.emittedPayrolls.totalEmittedPayrolls > 180000) {
          this.$notify({
            title: this.$t('invoices.invoices_entity_table.csv_title'),
            message: this.$t('invoices.invoices_entity_table.csv_message'),
            type: 'Warning',
            iconClass: 'ods-icon-warning',
            position: 'top-right',
            customClass: 'b2b-notification-info',
            duration: 10000
          })
        } else {
          params.activeLang = this.getActiveLang
          const filename = await this.handleDownloadAllCsv(params)
          this.$notify({
            title: this.$t('msg_generics.download_file_ok', { filename: filename }),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        }
      } catch (error) {
        console.log('handleDownloadAllCsvEmitted CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Reenvio de factura recibidad -dropdown
    handleCloseDialog () {
      this.$refs.formDialogResendInvoice.resetFields()
    },
    async handleCheckPayment (invoice) {
      this.invoiceNumber = invoice.invoiceNumber
      const load = this.$loading({
        lock: true,
        text: this.$t('invoice_detail.load.checking')
      })
      try {
        const params = {
          invoiceNoteId: invoice.id,
          searchType: this.searchType
        }
        this.paymentsData = await this.getInvoicePaymentData(params)
        if (!this.paymentsData || this.paymentsData === '') {
          this.$notify({
            title: this.$t('invoice_detail.notification.no_results_payment'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } else {
          this.setterShowPaymentDataDialog(true)
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    setterShowPaymentDataDialog (value) {
      if (!value) {
        this.paymentsData = []
      }
      this.isShowDialogPaymentData = value
    },

    // Creación de una factura
    async handleCreateInvoice (invoice) {
      const inv = {
        idInvoiceToRectificative: invoice.id
      }
      await this.createInvoiceState(inv)
      router.push({ name: 'creacion-factura-facturas-emitidas', query: { type: 'INVOICE_EMIT' } })
    },

    async handleResendInvoice (invoice) {
      const load = this.$loading({
        lock: true,
        text: this.$t('invoice_detail.load.resend_invoice')
      })
      try {
        this.handleCellMouseEnter(invoice)
        this.invoiceId = invoice.id
        const params = {
          invoiceNoteId: invoice.id,
          searchType: this.searchType
        }
        const factura = await this.getInvoiceNote(params)
        console.log('invoice', factura)
        await this.getProjectByNameOnDatabase(factura)

        // Métodos de envío
        let request = null
        console.log('factura.emission ', factura.emission)
        if (factura.emission === true || factura.emission === null) {
          request = {
            method: 'SEND',
            projectId: this.project.id,
            isResend: true
          }
        } else {
          request = {
            method: 'RECEIVE',
            projectId: this.project.id,
            invoiceId: factura.id,
            isResend: false,
            byProject: false,
            byBuyer: true,
            onlyVisible: false
          }
        }
        this.metodosenvio = await this.getOptionsProjectCommunicationsMethods(request)
        this.obtainCommunicationMethodId(invoice.communicationMethod)

        this.isShowDialogResendInvoice = true
      } finally {
        load.close()
      }
    },
    submitChangeStatus (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('invoice_detail.load.update_invoice')
          })
          console.log('submitChangeStatus: ', this.formDialogChangestatus)
          try {
            const params = {
              statusId: this.formDialogChangestatus.statusId,
              observations: this.formDialogChangestatus.observations,
              invoiceNoteId: this.multipleSelectionIds,
              searchType: this.searchType
            }

            await this.modifyMultipleStatus(params)

            // Refrescamos
            await this.getInvoicesOnDatabase()
            this.$refs[formName].clearValidate()
            this.isShowDialogChangestatus = false

            this.$notify({
              title: this.$t('invoice_detail.notification.submit_edit_invoices_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            console.log('submitChangeStatus CATCH: ', error)
            this.getNotificationErrorMessage(error)
            this.$refs[formName].resetFields()
          } finally {
            this.$refs[formName].resetFields()
            load.close()
          }
        } else {
          console.log('submitChangeStatus: ', this.formDialogChangestatus)
          return false
        }
      })
    },
    async getProjectByNameOnDatabase (invoice) {
      try {
        const proj = await this.getProjectByName(
          invoice.projectName
        )
        if (proj.length > 1) {
          this.project = proj[0]
        } else {
          this.project = proj
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    submitResendInvoice (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('invoice_detail.load.resend_invoice')
          })
          try {
            let multiple = false
            let params = {}
            let tittleConfirm = this.$t('invoice_detail.notification.resend_invoice_ok')
            let emailsToSend = []
            if (!this.dialogResendInvoiceForm.newEmails || this.dialogResendInvoiceForm.newEmails.trim() === '') {
              emailsToSend = []
            } else {
              emailsToSend = this.dialogResendInvoiceForm.newEmails.split(';')
            }
            if (this.multipleResendListIds !== undefined && this.multipleResendListIds !== null && this.multipleResendListIds.length !== 0 &&
              this.multipleResendListIds.length !== 1) {
              multiple = true
              tittleConfirm = this.$t('invoice_detail.notification.resend_invoices_ok')
              if (this.dialogResendInvoiceForm.communicationMethodId === 'DEFAULT') {
                this.dialogResendInvoiceForm.isDefault = true
                this.dialogResendInvoiceForm.communicationMethodId = null
              } else {
                this.dialogResendInvoiceForm.isDefault = null
              }
              params = {
                invoiceNoteId: this.multipleResendListIds,
                isDefault: this.dialogResendInvoiceForm.isDefault,
                communicationMethodId: this.dialogResendInvoiceForm.communicationMethodId,
                searchType: this.searchType,
                newEmails: emailsToSend
              }
              await this.handleResendMultipleInvoices(params)
            } else {
              if (this.multipleResendListIds !== undefined && this.multipleResendListIds !== null && this.multipleResendListIds.length !== 0 &&
              this.multipleResendListIds.length === 1) {
                multiple = true
                params = {
                  invoiceNoteId: this.multipleResendListIds[0],
                  communicationMethodId: this.dialogResendInvoiceForm.communicationMethodId,
                  searchType: this.searchType,
                  newEmails: emailsToSend
                }
              } else {
                const idList = [this.invoiceId]
                params = {
                  invoiceNoteId: idList,
                  isDefault: false,
                  communicationMethodId: this.dialogResendInvoiceForm.communicationMethodId,
                  searchType: this.searchType,
                  newEmails: emailsToSend
                }
              }
              if ((this.currentRow.status.toUpperCase() === 'RETAINED' || this.currentRow.status.toUpperCase() === 'RETENIDA') && this.currentRow.communicationMethod === null) {
                tittleConfirm = this.$t('invoice_detail.notification.submit_edit_invoice_ok') + '. ' + this.$t('invoice_detail.notification.resend_invoice_ko_retained')
              }
              await this.handleResendMultipleInvoices(params)
            }
            this.$notify({
              title: tittleConfirm,
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            this.$refs[formName].resetFields()
            this.isShowDialogResendInvoice = false
            await this.getInvoicesOnDatabase()

            if (!multiple) {
              const params = {
                invoiceNoteId: this.invoiceId,
                searchType: this.searchType
              }
              const factura = await this.getInvoiceNote(params)
              this.showResendButton(factura)
            }
            if ((this.multipleSelectionIds !== undefined && this.multipleResendListIds !== undefined) && (this.multipleSelectionIds.length !== this.multipleResendListIds.length)) {
              this.$notify({
                title: this.$t('invoice_detail.notification.resend_not_all'),
                type: 'Warning',
                iconClass: 'ods-icon-warning',
                position: 'top-right',
                customClass: 'b2b-notification-success',
                duration: 10000
              })
            }
          } catch (error) {
            console.log('submitResendInvoice CATCH: ', error)
            this.getNotificationErrorMessage(error)
            this.$refs[formName].resetFields()
            this.isShowDialogResendInvoice = false
          } finally {
            await this.getInvoicesOnDatabase()
            load.close()
          }
        } else {
          console.log('submitResendInvoice INVALID: ', this.dialogResendInvoiceForm)
          return false
        }
      })
    },
    async getInvoicesOnDatabase () {
      try {
        const dataQuery = { query: {} }
        this.options = filters.filters
        if (this.urlIn && this.urlIn !== 'b2b') {
          this.queryEmittedPayrolls.urlName = this.urlIn
        } else {
          this.queryEmittedPayrolls.urlName = null
        }
        this.currentPage = this.queryEmittedPayrolls.page + 1
        console.log('currentPage: ', this.currentPage)
        dataQuery.query = this.queryEmittedPayrolls
        await this.getPayrolls(dataQuery)

        console.log('JHB created payrollsList: ', this.payrollsList)
      } catch (error) {
        console.log('getPayrolls CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    async handleEmailsForResendInvoice () {
      // si no es envio multiple obtenemos el email por defecto del usuario
      if (!(this.multipleResendListIds !== undefined && this.multipleResendListIds !== null && this.multipleResendListIds.length !== 0)) {
        const load = this.$loading({
          lock: true,
          text: this.$t('invoice_detail.dialog_resend_invoice.get_emails')
        })
        if (this.showInputNewEmails(this.dialogResendInvoiceForm.communicationMethodId)) {
          await this.getResendEmails()
        }
        load.close()
      }
    },
    async getResendEmails () {
      try {
        const params = {
          invoiceNoteId: this.invoiceId,
          isDefault: false,
          communicationMethodId: this.dialogResendInvoiceForm.communicationMethodId,
          searchType: this.searchType,
          newEmails: this.dialogResendInvoiceForm.newEmails
        }
        const response = await this.getResendEmailsInvoiceNote(params)
        this.dialogResendInvoiceForm.newEmails = response.data.join(';')
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    // Carga por defecto el metodo de envio en el select de reenvio
    obtainCommunicationMethodId (commMethod) {
      if (this.metodosenvio && this.metodosenvio.length === 1) {
        this.dialogResendInvoiceForm.communicationMethodId = this.metodosenvio[0].id
      } else if (commMethod) {
        this.metodosenvio.forEach(element => {
          if (element.code.toUpperCase() === commMethod.toUpperCase()) {
            this.dialogResendInvoiceForm.communicationMethodId = element.id
          }
        })
      }
    },

    changeStatus (data) {
      this.optionsFilterInvoiceStatus.find(function (t) {
        return t.id === data
      })
      this.$refs.formDialogChangestatus.clearValidate()
    },

    // Conseguir datos de la fila en el hover del ratón
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },

    // Selección de Filas con el checkbox
    handleSelectionChange (val) {
      this.multipleSelection = val
      if (val.length === 0) {
        this.multipleSelection = []
      }
      this.multipleSelectionIds = this.multipleSelection.map(item => item.id)

      this.multipleResendList = this.multipleSelection.filter(item => item.emission !== null && item.status !== 'RETAINED')

      this.multipleResendListIds = this.multipleResendList.map(item => item.id)
      this.multipleResendListProjects = this.multipleResendList.map(item => item.projectName).filter((x, i, a) => a.indexOf(x) === i)
    },

    // Ir al detalle
    handleGoDetail (invoice) {
      this.handleCellMouseEnter(invoice)
      this.selectInvoiceNote(invoice)
      sessionStorage.setItem('invoiceNumber', this.currentRow.invoiceNumber)
      router.push({
        name: 'factura-emitida-detail',
        params: {
          invoiceNoteId: this.currentRow.id,
          invoiceNumber: this.currentRow.invoiceNumber
        }
      })
    },
    // Descargar 1A factura pdf - Fast Accion
    async handleDownloadPdf (invoice) {
      this.handleCellMouseEnter(invoice)
      this.invoiceId = invoice.id
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })
      try {
        const idList = [invoice.id]
        const filename = await this.handleDownloadMultiInvoiceNotesPdf({
          invoiceNoteId: idList,
          searchType: this.searchType
        })
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadInvoicePdf CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Descargar 1B factura original - Fast Accion
    async handleDownloadSignedOriginal (invoice) {
      this.handleCellMouseEnter(invoice)
      this.invoiceId = invoice.id
      const idList = [invoice.id]
      console.log('handleDownloadSignedOriginal: ', this.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_invoice_original')
      })
      try {
        const params = {
          invoiceNoteId: idList,
          searchType: this.searchType
        }
        const filename = await this.handleDownloadMultiInvoiceSignedOriginal(params)
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadSignedOriginal CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Descargar 1C factura formateada - Fast Accion
    async handleDownloadOriginalformatted (invoice) {
      this.handleCellMouseEnter(invoice)
      this.invoiceId = invoice.id
      console.log('handleDownloadOriginalformatted: ', this.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_invoice_formatted')
      })
      try {
        const params = {
          invoiceNoteId: this.invoiceId,
          searchType: this.searchType
        }
        const filename = await this.downloadInvoiceFormatted(params)
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadOriginalformatted CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Ver 2 XLS - Fast accion
    async handleDownloadXLS (invoice) {
      this.handleCellMouseEnter(invoice)
      this.invoiceId = invoice.id

      try {
        const params = {
          invoiceNoteId: this.invoiceId,
          documentFormat: invoice.documentFormat,
          searchType: this.searchType
        }

        const html = await this.visualizeWithXsl(params)

        const newTab = window.open('_blank')
        newTab.document.write(html.data)
        newTab.document.close()
      } catch (error) {
        console.log('showVisualizeButton CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    // Ver 3 Metadata quickaccions Emitidas -dropdown
    async handleDownloadMetadata (invoice) {
      console.log('handleDownloadMetadata: ', this.invoiceId)
      this.handleCellMouseEnter(invoice)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_metadata')
      })
      try {
        const params = {
          invoiceNoteId: invoice.id,
          searchType: this.searchType
        }
        await this.downloadMetadata(params)
        load.close()
        this.$notify({
          title: this.$t('msg_generics.download_metadata_ok'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadMetadata CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Ver 3.1 Metadata Recibidas-Emitidas -dropdown
    async handleGenerateMetadata (invoice) {
      this.handleCellMouseEnter(invoice)
      console.log('handleGenerateMetadata: ', this.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_metadata')
      })

      try {
        await this.generateMetadata({
          invoiceNoteId: invoice.id,
          searchType: this.searchType
        })
        load.close()
        this.$notify({
          title: this.$t('msg_generics.download_metadata_ok'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleGenerateMetadata CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Formatear metodo de envio
    formatterCommunicationMethod (row, column) {
      if (row[column.property]) return this.$t('communication_method.' + row[column.property])
      else return ''
    },

    formatterTooltipInvoiceStatus (row, column) {
      if (row.messageStatus && row.messageStatus !== '') return this.formatterInvoiceStatus(row, column) + ' - ' + row.messageStatus
      else return this.formatterInvoiceStatus(row, column)
    },

    // Formatear estado de la factura
    formatterInvoiceStatus (row, column) {
      return this.$t('invoice_status.' + row[column.property])
    },

    // Formatear divisa
    formatterCurrency (row, column) {
      if (row[column.property]) {
        return this.$t('currency.' + row[column.property])
      } else {
        return ''
      }
    },
    // Formatear forma de pago
    formatterPaymentMethod (row, column) {
      if (row[column.property]) {
        return this.$t('paymentmethod.' + row[column.property])
      } else {
        return ''
      }
    },
    // Formatear clase de factura
    formatterClass (row, column) {
      if (row[column.property]) {
        return this.$t('document_class.' + row[column.property])
      } else {
        return ''
      }
    },
    // Formatear dinero Tabla
    formatterMoney (row, column) {
      const currency = this.optionsFilterCurrency.find(e => e.code === row.currencyCode)
      let negative = false
      let money = this.$n(row[column.property], 'table')
      // le quitamos la parte negativa
      if (money.startsWith('-')) {
        negative = true
        money = money.substring(1)
      }
      // para la longitud de 7 (nnnn,nn)la función $n no le pone el separador de miles
      // lo hacemos manualmente
      if (money.toString().length === 7) {
        const part1 = money.substring(0, 1)
        const part2 = money.substring(1, 7)
        money = part1 + '.' + part2
      }
      // Añadimos la divisa si la tiene
      if (currency && currency.symbol) {
        money += ' ' + currency.symbol
      }
      // si la cantidad era negativa se le pone el menos
      if (negative) {
        money = '-' + money
      }
      return money
    },

    // Formatear fechas Tabla
    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        if (column.property === 'creationDateTime') return date.format(this.$t('date_format_long'))
        else return date.format(this.$t('date_format'))
      }
      if (column.property === 'accountingDate' || column.property === 'paymentDate') { return '' } else return this.$t('msg_generics.no_date')
    },
    // Formatea un booleano en si no
    formatterBoolean (row) {
      if (row.cancellationRequest === true) {
        return this.$t('msg_generics.question.yes')
      } else {
        return this.$t('msg_generics.question.no')
      }
    },

    // JSX Menu Tabla
    renderHeaderActions: h => {
      return <B2bTableMenuFacturas />
    },

    // Tamaño Tabla (20,50,100)
    async handleSizeChange (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.size_table')
      })
      try {
        const dataQuery = { query: {} }
        this.queryEmittedPayrolls.size = val
        if (this.urlIn && this.urlIn !== 'b2b') {
          this.queryEmittedPayrolls.urlName = this.urlIn
        } else {
          this.queryEmittedPayrolls.urlName = null
        }
        await this.queryEmittedPayrollsState(this.queryEmittedPayrolls)
        dataQuery.query = this.queryEmittedPayrolls
        await this.getPayrolls(dataQuery)
      } catch (error) {
        console.log('handleSizeChange CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Paginacion
    async handleCurrentChangePagination (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.pagination_table')
      })

      try {
        const dataQuery = { query: {} }
        this.queryEmittedPayrolls.page = val - 1
        if (this.urlIn && this.urlIn !== 'b2b') {
          this.queryEmittedPayrolls.urlName = this.urlIn
        } else {
          this.queryEmittedPayrolls.urlName = null
        }
        await this.queryEmittedPayrollsState(this.queryEmittedPayrolls)
        dataQuery.query = this.queryEmittedPayrolls
        const payrolls = await this.getPayrolls(dataQuery)
        console.log('PAYROLLS:::: ', payrolls)
      } catch (error) {
        console.log('handleCurrentChangePagination CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Seleccionadas
    async handleDownloadInvoice () {
      const paramsValues = this.multipleSelectionIds.filter((item, index, self) => {
        return index === self.indexOf(item)
      })
      const load = this.$loading({
        lock: true,
        text: this.$t('invoices.loading.download_invoices')
      })
      console.log('handleDownloadInvoice() VALUES ->', paramsValues)
      try {
        const filename = await this.handleDownloadMultiInvoiceNotesPdf({
          invoiceNoteId: paramsValues,
          searchType: this.searchType
        })
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadInvoice CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async handleDownloadOriginalInvoice () {
      console.log('handleDownloadOriginalInvoice() ->', this.multipleSelection)
      const load = this.$loading({
        lock: true,
        text: this.$t('invoices.loading.download_invoices_original')
      })

      try {
        const params = {
          invoiceNoteId: this.multipleSelectionIds,
          searchType: this.searchType
        }
        const filename = await this.handleDownloadMultiInvoiceSignedOriginal(params)
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadOriginalInvoice CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async openhandleResendMultiple () {
      if (this.multipleResendListProjects.length === 1) {
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.load_init')
        })
        try {
          try {
            const proj = await this.getProjectByName(this.multipleResendListProjects[0])
            if (proj.length > 1) {
              this.project = proj[0]
            } else {
              this.project = proj
            }
          } catch (error) {
            this.getNotificationErrorMessage(error)
          }

          const request = {
            method: 'SEND',
            projectId: this.project.id,
            isResend: true
          }
          if (request !== null) {
            this.metodosenvio = await this.getOptionsProjectCommunicationsMethods(request)
            console.log(this.multipleResendList[0].communicationMethod)
            if (this.multipleResendList !== undefined && this.multipleResendList !== null) {
              if (this.multipleResendList.length === 1) {
                this.obtainCommunicationMethodId(this.multipleResendList[0].communicationMethod)
              } else if (this.multipleResendList.length > 1) {
                this.metodosenvio.push({ id: 'DEFAULT', code: 'DEFAULT' })
                console.log(JSON.stringify(this.metodosenvio))
                this.obtainCommunicationMethodId('DEFAULT')
                this.dialogResendInvoiceForm.isDefault = true
              }
            }
          }
        } finally {
          load.close()
          this.isShowDialogResendInvoice = true
        }
      } else {
        if (this.multipleResendListIds.length === 0) {
          this.$notify({
            title: this.$t('invoice_detail.notification.resend_any'),
            type: 'warning',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } else {
          // MENSAJE DE SOLO SE PUEDE REENVIAR PARA UN SERVICIO
          this.$notify({
            title: this.$t('invoice_detail.notification.resend_same_project'),
            type: 'error',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        }
      }
    },

    async handleChangestatusMultiple () {
      this.isShowDialogChangestatus = true
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error ? error.status : 0
      switch (statusCode) {
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
        case 400:
        case 500:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          } else if (errorSms && errorSms.indexOf('does not exist') > -1) {
            errorSms = 'No se puede consultar la información para este servicio'
          }
          break
        case 409:
          errorSms = error.data.message
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      let errorArgList = []

      errorArgList = error.data.errorArgList
      console.log('--> errorArgList ', errorArgList)
      if (errorArgList && errorArgList[0].messageCode !== null) {
        for (let i = 0; i < errorArgList.length; i++) {
          const fullMessage = errorArgList[i].messageCode
          if (errorArgList[i].arguments === 'Ok.') {
            console.log('--> fullMessage ', fullMessage)
            console.log('--> fullMessage ', fullMessage.indexOf('se ha actualizado correctamente'))
          }
          if (errorArgList[i].arguments === 'Warn.') {
            await this.$notify({
              title: fullMessage,
              type: 'warning',
              position: 'top-right',
              customClass: 'b2b-notification-info',
              duration: 60000
            })
          } else {
            await this.$notify({
              title: fullMessage,
              type: 'error',
              position: 'top-right',
              customClass: 'b2b-notification-error',
              duration: 60000
            })
          }
        }
      } else {
        this.showNotificationError(error)
      }
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      const dataQuery = { query: {} }
      this.options = filters.filters
      const dataQueryProj = { page: 0, size: 1000, sort: 'name,ASC', isSender: true }
      const optionsFilterService = await this.getOptionsService(dataQueryProj)
      await this.optionsFilterServiceState(optionsFilterService)

      if (optionsFilterService.length === 1) {
        this.queryEmittedPayrolls.projectId = optionsFilterService[0].id
      }
      this.currentPage = this.queryEmittedPayrolls.page + 1
      if (this.urlIn && this.urlIn !== 'b2b') {
        this.queryEmittedPayrolls.urlName = this.urlIn
      } else {
        this.queryEmittedPayrolls.urlName = null
      }
      dataQuery.query = this.queryEmittedPayrolls
      await this.getPayrolls(dataQuery)
    } catch (error) {
      console.log('getPayrolls CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-table-facturas-emitidas {
  ::v-deep .ods-table {
    th {
      padding: rem(0);
      padding-top: rem(4);
      .cell {
        font-weight: 500;
      }
      .ods-dropdown{
        padding-left: 0px;
        padding-right: 0px;
      }

      &:last-child {
        padding-top: rem(0);
        .cell {
          .ods-dropdown {
            line-height: 32px;
          }
        }
      }
      .cell:last-child {
        .ods-dropdown {
          line-height: 32px;
        }
      }
    }
    &__row {
      .cell {
        .text-overflow-tooltip {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .ods-button {
        padding: rem(1) rem(15) rem(0) rem(15);
        margin-left: rem(0);
        margin-right: rem(0);
        i {
          margin-left: rem(0);
        }
      }
    }
  }

  ::v-deep &__pagination {
    margin: rem(32) rem(24) rem(32) rem(24);
    &--left {
      .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    }
    &--right {
      .block {
        float: right;
      }
    }
  }
}
</style>
<style lang="scss">
  .text-red {
    color: #ff0000;
  }
  .ods-notification {
    width: 450px!important;
  }
  .ods-popover {
    margin-right: 15px;
  }
</style>
